import React from 'react'
import Layout from '../components/Layout'
import UpdateTicketType from '../components/UpdateTicketType'

const UpdateTicket = () => {
  return (
    <div>
        <Layout/>
        <UpdateTicketType/>
    </div>
  )
}

export default UpdateTicket